// extracted by mini-css-extract-plugin
export default {"wrapper":"Qk-z","reviewFormSuccess":"Rk-z","header":"Sk-z","message":"Tk-z","paragraph":"Uk-z","lottieContainer":"Vk-z"};